// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import relEntity from './entities/rel.json';
import relMenu from '../pages/rel/menu.json';
import relFullForm from '../pages/rel/forms/full.json';
import relContextForm from '../pages/rel/forms/context.json';
import relMiniForm from '../pages/rel/forms/mini.json';
import relLookupForm from '../pages/rel/forms/lookup.json';
import relTableView from '../pages/rel/views/table.json';
import relStagesView from '../pages/rel/views/stages.json';
import relCardsView from '../pages/rel/views/cards.json';
import relInlineView from '../pages/rel/views/inline.json';
import relBacklogView from '../pages/rel/views/backlog.json';
import relSplitView from '../pages/rel/views/split.json';
import relCalendarView from '../pages/rel/views/calendar.json';
import relDashboardView from '../pages/rel/views/dashboard.json';

/** Тип запису «Зв’язок» зі сторінками пакета: меню, форми та подання з pages/rel/. */
export const relDefinition: IRecordTypeDefinition = {
  ...relEntity,
  views: assembleViewSet({
      table: relTableView,
      stages: relStagesView,
      cards: relCardsView,
      inline: relInlineView,
      backlog: relBacklogView,
      split: relSplitView,
      calendar: relCalendarView,
      dashboard: relDashboardView,
  }),
  form: relFullForm,
  forms: { full: relFullForm, context: relContextForm, mini: relMiniForm, lookup: relLookupForm },
  menu: relMenu,
} as IRecordTypeDefinition;
